module.exports = __webpack_public_path__ + "img/button_Refresh.dc50ddee.svg";